
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "25 conseils pour optimiser sa fiche d'entreprise sur Google",
    description:
      "Découvrez 25 conseils pour optimiser votre fiche Google et améliorer votre classement local. Augmentez votre visibilité en ligne et attirez plus de clients.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
